import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import LogAttachFileRequest from '../../../logs/analysis/i-service/models/request/LogAttachFileRequest';
import LogListRequest from '../../../logs/analysis/i-service/models/request/LogListRequest';
import GetLogFileRequest from '../../../logs/analysis/i-service/models/response/GetLogFileRequest';
import RenameFileLogResponse from '../../../logs/analysis/i-service/models/response/RenameFileLogResponse';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import LogListItemResponse from '../../../logs/analysis/i-service/models/response/LogListItemResponse';
import LogListResponse from '../../../logs/analysis/i-service/models/response/LogListResponse';
import LogFileAnalysisResponse from '../../../logs/analysis/i-service/models/response/analysis/LogFileAnalysisResponse';
import MethodTimeLoad from '../../../logs/analysis/i-service/models/response/analysis/MethodTimeLoad';

export default class LogsAnalysisService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	AttachFileLogEvent = new Events<WsResponseModelT<LogListItemResponse>>();
	GetFileLogEvent = new Events<WsResponseModelT<LogListResponse>>();
	RemoveFileLogEvent = new Events<WsResponseModelT<Boolean>>();
	RenameFileLogEvent = new Events<WsResponseModelT<Boolean>>();
	GetLogFileAnalysisDataEvent = new Events<WsResponseModelT<LogFileAnalysisResponse>>();
	GetMethodAnalysisDataEvent = new Events<WsResponseModelT<MethodTimeLoad>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('LogsAnalysisService', 'AttachFileLog', 'Main', (res: WsResponseModelT<LogListItemResponse>) => {
			self.AttachFileLogEvent.trigger(res);
		});
		webApiService.on('LogsAnalysisService', 'GetFileLog', 'Main', (res: WsResponseModelT<LogListResponse>) => {
			self.GetFileLogEvent.trigger(res);
		});
		webApiService.on('LogsAnalysisService', 'RemoveFileLog', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFileLogEvent.trigger(res);
		});
		webApiService.on('LogsAnalysisService', 'RenameFileLog', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RenameFileLogEvent.trigger(res);
		});
		webApiService.on('LogsAnalysisService', 'GetLogFileAnalysisData', 'Main', (res: WsResponseModelT<LogFileAnalysisResponse>) => {
			self.GetLogFileAnalysisDataEvent.trigger(res);
		});
		webApiService.on('LogsAnalysisService', 'GetMethodAnalysisData', 'Main', (res: WsResponseModelT<MethodTimeLoad>) => {
			self.GetMethodAnalysisDataEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Добавить файл логов
	 */
	async AttachFileLog(request: LogAttachFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'AttachFileLog',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список файлов
	 */
	async GetFileLog(request: LogListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'GetFileLog',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление файла логов
	 */
	async RemoveFileLog(request: GetLogFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'RemoveFileLog',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Переименовать
	 */
	async RenameFileLog(request: RenameFileLogResponse) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'RenameFileLog',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Анализ лог файла
	 */
	async GetLogFileAnalysisData(request: GetLogFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'GetLogFileAnalysisData',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Анализ лог файла
	 */
	async GetMethodAnalysisData(request: GetLogFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'LogsAnalysisService',
			Method: 'GetMethodAnalysisData',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Добавить файл логов
	 */
	async attachFileLogAsync(request: LogAttachFileRequest): Promise<LogListItemResponse> {
		return new Promise<LogListItemResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'AttachFileLog',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<LogListItemResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as LogListItemResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список файлов
	 */
	async getFileLogAsync(request: LogListRequest): Promise<LogListResponse> {
		return new Promise<LogListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'GetFileLog',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<LogListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as LogListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление файла логов
	 */
	async removeFileLogAsync(request: GetLogFileRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'RemoveFileLog',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Переименовать
	 */
	async renameFileLogAsync(request: RenameFileLogResponse): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'RenameFileLog',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Анализ лог файла
	 */
	async getLogFileAnalysisDataAsync(request: GetLogFileRequest): Promise<LogFileAnalysisResponse> {
		return new Promise<LogFileAnalysisResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'GetLogFileAnalysisData',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<LogFileAnalysisResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as LogFileAnalysisResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Анализ лог файла
	 */
	async getMethodAnalysisDataAsync(request: GetLogFileRequest): Promise<MethodTimeLoad> {
		return new Promise<MethodTimeLoad>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'LogsAnalysisService',
				Method: 'GetMethodAnalysisData',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<MethodTimeLoad>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as MethodTimeLoad)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}